import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AppComponent } from './app.component';
import {AppRoutingModule} from "./app.routing";
import {CustomHttpService} from "./services/CustomHttp.service";
import {LoginService} from "./services/login.service";
import {ErrorService} from "./common/errors/error.service";
import {ApplicationService} from "./services/application.service";
import {LocalStorageService} from "./services/LocalStorage.service";
import {OnlineServiceAuthGuard} from "./common/OnlineServiceAuthGuard";
import {CommonService} from "./services/common.service";
import {ModalModule} from "ng2-bootstrap/index";
import {InformationService} from "./services/information.service";
import {FileValidation} from "./common/validation/FileValidation";
import {ConfirmationService, GrowlModule  } from "primeng/primeng";
import {ErrorComponent} from "./common/errors/error.component";
import {SpinnerService} from "./common/spinner/spinner.service";
import {SpinnerComponent} from "./common/spinner/spinner.component";
import {AutoCompleteModule} from "./common/primeng/autocomplete/autocomplete";
import { OrderByPipe } from './common/directives/OrderBy.pipe';

@NgModule({
  declarations: [
    AppComponent,
    ErrorComponent,
    SpinnerComponent,
    OrderByPipe
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    AppRoutingModule,
    GrowlModule,
    ModalModule.forRoot(),
    AutoCompleteModule
  ],
  providers: [CustomHttpService,LoginService,ErrorService,ApplicationService,
    LocalStorageService,OnlineServiceAuthGuard,CommonService, ConfirmationService, FileValidation,InformationService,
    SpinnerService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts